import React from "react";
import { useState, useEffect, useRef } from "react";
import "../CaseStudies1/CaseStudies1.scss";
import img from "../../assets/images/case-studies-details/optimizing-supply.png";
import meta_tags from "../../Data/MetaTags";
import { useLocation } from "react-router-dom";
function CaseStudiesoptimizing() {
  const [rendercount, setRenderCount] = useState(() => false);

  const location = useLocation();

  useEffect(() => {
    setRenderCount(true);
    if (rendercount === true) {
     
      document.title = meta_tags[location.pathname.replace("/", "")]
        ? meta_tags[location.pathname.replace("/", "")].title
        : "";
     
      document.getElementById("meta-tags").content = meta_tags[
        location.pathname.replace("/", "")
      ]
        ? meta_tags[location.pathname.replace("/", "")].content
        : "";
      document.getElementById("canonical-link").href = meta_tags[
        location.pathname.replace("/", "")
      ]
        ? meta_tags[location.pathname.replace("/", "")].link
        : "";
     
      if (!(document.getElementById("link1") == null)) {
        document.getElementById("link1").remove();
        document.getElementById("link2").remove();
        document.getElementById("link3").remove();
        document.getElementById("link4").remove();
        document.getElementById("link5").remove();
        document.getElementById("link6").remove();
      }
    }
  }, [rendercount]);

  return (
    <>
     
      <section className="details-sec">
        <div className="container">
          <div className="heading-sec">
            <h3>Optimizing Supply Chain Management with Prime</h3>
          </div>
          <div>
            <p className="sm-para">
              ABC FMCG Corporation, a global player in the FMCG industry, faced
              challenges in managing its supply chain efficiently due to its
              extensive network spanning multiple regions. The company struggled
              with inventory stockouts, excess holding costs, and inefficient
              distribution processes.
            </p>
          </div>
          <div className="details-contents">
            <h3>Challenge:</h3>
            <p className="sm-para">
              ABC FMCG Corporation needed a solution to streamline its
              operations, enhance inventory visibility, and improve demand
              forecasting accuracy to address its supply chain challenges
              effectively.
            </p>
          </div>
          <div className="details-contents">
            <h3>
              Solution: <span className="sm-para">Prime Implementation</span>
            </h3>
            <ul>
              <li className="sm-para">
                <strong>Demand Forecasting and Planning:</strong> Prime analyzed
                ABC's historical sales data and market trends to forecast demand
                accurately. For instance, by analyzing sales data from the past
                year, Prime predicted a surge in demand for a particular product
                during the summer months. This insight allowed ABC to adjust its
                inventory levels and production schedules accordingly, avoiding
                stockouts and maximizing sales opportunities.
              </li>
              <li className="sm-para">
                <strong>Inventory Optimization:</strong> With Prime's real-time
                inventory visibility and demand forecasting capabilities, ABC
                optimized its inventory levels across its supply chain network.
                For example, based on Prime's analysis, ABC reduced its
                inventory of slow-moving items stored in warehouses in certain
                regions where demand was low, reallocating resources to regions
                experiencing higher demand. This resulted in reduced excess
                inventory holding costs without compromising product
                availability.
              </li>
              <li className="sm-para">
                <strong>Supplier Collaboration:</strong> Prime facilitated
                seamless collaboration with suppliers, enabling ABC to improve
                procurement processes and supplier performance. For instance, by
                leveraging Prime's automated purchase order management, ABC
                communicated real-time inventory requirements to its suppliers,
                reducing lead times and ensuring timely deliveries.
                Additionally, Prime's supplier scorecards and performance
                analytics helped ABC identify underperforming suppliers and
                negotiate better terms, leading to cost savings.
              </li>
              <li className="sm-para">
                <strong>Logistics Optimization:</strong> ABC utilized Prime's
                advanced logistics optimization capabilities to streamline
                transportation routes and minimize shipping costs. For example,
                Prime's route optimization algorithms identified the most
                cost-effective routes for delivering products to retail stores
                based on factors such as distance, traffic patterns, and
                delivery schedules. By optimizing its distribution network, ABC
                reduced transportation costs and improved delivery reliability,
                enhancing customer satisfaction.
              </li>
            </ul>
          </div>
          <div className="details-contents">
            <h3>Results:</h3>
            <p>
              By implementing Prime, ABC FMCG Corporation achieved significant
              improvements in supply chain management –
            </p>
            <ul>
              <li className="sm-para">
                <strong>Reduced inventory holding costs and stockouts:</strong>{" "}
                ABC experienced a 20% decrease in excess inventory holding costs
                and a 15% reduction in stockouts, leading to improved
                profitability.
              </li>
              <li className="sm-para">
                <strong>
                  Improved demand forecasting accuracy and inventory visibility:
                </strong>{" "}
                Prime's accurate demand forecasts and real-time inventory
                visibility enabled ABC to respond quickly to changes in market
                demand, resulting in optimized inventory levels and increased
                sales.
              </li>
              <li className="sm-para">
                <strong>Enhanced collaboration with suppliers:</strong> ABC
                strengthened its relationships with suppliers, resulting in
                improved supplier performance and cost savings of 10% on
                procurement.
              </li>
              <li className="sm-para">
                <strong>Optimized logistics operations:</strong> ABC reduced
                shipping costs by 15% and improved delivery reliability by 20%
                by leveraging Prime's logistics optimization capabilities.
              </li>
            </ul>
          </div>
          <div className="details-contents">
            <p className="sm-para">
              Overall, Prime empowered ABC FMCG Corporation to optimize its
              supply chain operations, increase efficiency, and gain a
              competitive advantage in the dynamic FMCG industry.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default CaseStudiesoptimizing;
